import React from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'

import { FormattedMessage } from 'sb-react-intl'

import DialogModalComponent from 'components/modal/DialogModal/DialogModal'


const DialogModal = ({ name, data: { title, content, contentMessage, buttonTitle, ...data } }) => (
  <DialogModalComponent
    name={name}
    title={title}
    buttonTitle={buttonTitle}
    data={data}
  >
    {
      contentMessage ? (
        <FormattedMessage {...contentMessage} name="components.modals.DialogModal" />
      ) : (
        content
      )
    }
  </DialogModalComponent>
)

DialogModal.propTypes = {
  name: PropTypes.string.isRequired,
  data: PropTypes.object,
}

DialogModal.defaultProps = {
  name: constants.modals.Dialog,
}

export default DialogModal
